import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function BusinessProtectedRoute() {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Check if user has business role
  if (user?.role !== "business") {
    return <Navigate to="/admin/auth/login" replace />;
  }

  // Check if user needs to reset password and is not already on the change password page
  if (user?.is_reset_password_after_login && location.pathname !== "/business/first-change-password") {
    return <Navigate to="/business/first-change-password" replace />;
  }

  return <Outlet />;
}
